import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "checkmark"];
  static values = { text: String };

  copy() {
    if (!this.hasTextValue) return;

    navigator.clipboard.writeText(this.textValue).then(() => {
      if (this.hasCheckmarkTarget) {
        this.checkmarkTarget.classList.remove("hidden");

        if (this.hasButtonTarget) {
          this.buttonTarget.disabled = true;
        }

        setTimeout(() => {
          this.checkmarkTarget.classList.add("hidden");

          if (this.hasButtonTarget) {
            this.buttonTarget.disabled = false;
          }
        }, 2000);
      }
    }).catch((error) => {
      alert(`Failed to copy to clipboard: ${error.message}`);
    });
  }
}
